import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import type { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";

export function locationsErrorMessageForLocationType(
  _locationType: LocationType | undefined,
): ErrorMessageType {
  if (_locationType === undefined) {
    return "Required";
  }
  return undefined;
}
